import { Loading, Message } from 'element-ui';
let tool = {
      // 时间段格式化
      /**
       * time 需要格式化得时间
       * format 格式化样式 字符串格式传入 例如 "YYYY年MM月WW周DD日HH小时mm分钟ss秒"
       *
       * type: 传入得时间类型 不传视为传得毫秒
       * HH-小时 mm-分钟 ss-秒 ms-毫秒 DD-天 WW-周 MM-月 YYYY-年
       *
       *
       * 例 timeFormatting(200,'minutes','HH小时mm分钟ss秒')   输入 3小时20分钟0秒
       */
       timeFormatting(time,format,type) {
          let config = [];//format中已设置的时间格式化单位
          // 每一个时间单位转化为毫秒数
          let secondsMs = 1000;
          let minutesMs = 60*secondsMs;
          let hourMs = 60*minutesMs;
          let dayMs = 24*hourMs;
          let monthMs = 30*dayMs;
          let weeksMs = 7*dayMs;
          let yearsMs = 365*dayMs;

          // 定义所有时间配置
          let fullConfig = [{code:'YYYY',ms:yearsMs,},{code:'MM',ms:monthMs,},{code:'WW',ms:weeksMs,},{code:'DD',ms:dayMs,},{code:'HH',ms:hourMs,},{code:'mm',ms:minutesMs,},{code:'ss',ms:secondsMs,}];

          let timeObj = {ms:0,minTimeUnit:'YYYY'};//最终所有的数据都会存在该对象中

          // 根据传入的type 来将时间转化为相依的毫秒数
          let typeConfig = fullConfig.find((ele)=>{
            return ele.code == type;
          })

          timeObj.ms =typeConfig ? typeConfig.ms * time : time;
          //  获取配置 并计算出各个时间单位的数值
            fullConfig.forEach(ele=>{
              if(format.indexOf(ele.code) > -1){
                config.push(ele.code);
                timeObj.minTimeUnit = ele.code;
                timeObj[ele.code] = timeObj.ms/ele.ms;
                timeObj.ms = timeObj.ms - parseInt(timeObj[ele.code]) * ele.ms;
              }

            })

            // 设置时间 根据获取的配置来将数值对象替换传入的format中的内容
            config.forEach(ele=>{
              if(format.indexOf(ele) >-1){
                let reg = new RegExp(ele,'g');
                console.log(timeObj.minTimeUnit)
                if(timeObj.minTimeUnit == ele){
                  format = format.replace(reg,timeObj[ele].toFixed(2));
                }else{
                  format = format.replace(reg,parseInt(timeObj[ele]));
                }
              }
            })

            return format;
        },

      // 将对象拼接成路径传参格式字符串
      objToform(obj) {
        let result = [];
        Object.keys(obj).forEach(ele => {
          result.push(`${ele}=${obj[ele]}`);
        })
        return result.join('&');
      },
     // 换取字典值方法
     getDictionaryValue(dictList,key,value,inValue){
        //  dictList: 字典数组
        //  key:需要得到得字段
        //  value:对比得字段
        //  inValue:传入对比字段得值
        let result = null;
        dictList.forEach(item=>{
          if(item[value]==inValue){
            result = item[key];
            return;
          }
        })
        return result||inValue;
      },
      /*
        *金额格式化
        * 参数说明：
        * money：要格式化的数字
        * decimals：保留几位小数
        * dec_point：小数点符号
        * thousands_sep：千分位符号
        * */
       money_format(money, decimals, dec_point, thousands_sep) {
        decimals?decimals:decimals=2
        money = (money + '').replace(/[^0-9+-Ee.]/g, '');
        var n = !isFinite(+money) ? 0 : +money,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.ceil(n * k) / k;
            };

        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        var re = /(-?\d+)(\d{3})/;
        while (re.test(s[0])) {
            s[0] = s[0].replace(re, "$1" + sep + "$2");
        }

        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    },
    /*
        *金额格式化 无金额返回空
        * 参数说明：
        * money：要格式化的数字
        * decimals：保留几位小数
        * dec_point：小数点符号
        * thousands_sep：千分位符号
        * */
        money_format_allowvoid(money, decimals, dec_point, thousands_sep) {
          if(!money){
            return money
          }
          decimals?decimals:decimals=2
          money = (money + '').replace(/[^0-9+-Ee.]/g, '');
          var n = !isFinite(+money) ? 0 : +money,
              prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
              sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
              dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
              s = '',
              toFixedFix = function (n, prec) {
                  // var k = Math.pow(10, prec);
                  // return '' + Math.ceil(n * k) / k;
                  return n.toFixed(prec)
              };

          s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
          var re = /(-?\d+)(\d{3})/;
          while (re.test(s[0])) {
              s[0] = s[0].replace(re, "$1" + sep + "$2");
          }

          if ((s[1] || '').length < prec) {
              s[1] = s[1] || '';
              s[1] += new Array(prec - s[1].length + 1).join('0');
          }
          return s.join(dec);
      },

      /**
       * 下载
       */

       downloadFile(url){
         console.log('url',url)
        window.open(url)

          // var form= document.createElement("form");
          // console.log(form)
          // form.setAttribute("style","display:none");
          // form.setAttribute("target","");
          // form.setAttribute("method","get");
          // form.setAttribute("action",url);
          // document.body.append(form);
          // form.submit();//表单提交}

          // var a= document.createElement("a");
          // a.setAttribute("style","display:none;z-index:10000;position:fixed;top:50%;left:50%;");
          // a.setAttribute("download",true);
          // // a.innerHTML="下载中..."
          // a.setAttribute('href',url);
          // document.body.append(a);
          // console.log(a.click());

      },

      //清空对象
     clearObject(object,ignoreKey=''){
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
            if(key!=ignoreKey){
              object[key]=returnVoid(object[key])
            }
        }
      }

     },
     formateObjToParamStr(paramObj) {
      const sdata = [];
      for (let attr in paramObj) {
        sdata.push(`${attr}=${filter(paramObj[attr])}`);
      }
      return sdata.join('&');
    },
    // 下划线转驼峰    
    convertToCamelCase(str) {
      return str.toLowerCase().replace(/_(.)/g, (match, group1) => {
        return group1.toUpperCase();
      });
    }
}
export default tool;
function returnVoid(value) {
  let type = Object.prototype.toString.call(value)
  let newValue
  switch(type){
    case  "[object Array]":
    newValue = []
    break;
    case  "[object Object]":
    newValue = {}
    break;
    case  "[object String]":
    newValue = ''
    break;
    default:
    newValue = ''
    break
  }
  return newValue
}
function filter(str) { // 特殊字符转义
  str += ''; // 隐式转换
  str = str.replace(/%/g, '%25');
  str = str.replace(/\+/g, '%2B');
  str = str.replace(/ /g, '%20');
  str = str.replace(/\//g, '%2F');
  str = str.replace(/\?/g, '%3F');
  str = str.replace(/&/g, '%26');
  str = str.replace(/\=/g, '%3D');
  str = str.replace(/#/g, '%23');
  return str;
}
